var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/afterpay-info/step2-small.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg class=\"i-afterpay-process-icon\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" x=\"0px\" y=\"0px\"\n     viewBox=\"0 0 100 100\" style=\"enable-background:new 0 0 100 100;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n    .st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n</style>\n<path class=\"st0\" d=\"M74.5,14.7v70.6c0,2.3-1.9,4.2-4.2,4.2H29.7c-2.3,0-4.2-1.9-4.2-4.2V14.7c0-2.3,1.9-4.2,4.2-4.2h40.6\n    C72.6,10.5,74.5,12.4,74.5,14.7z\"/>\n<line class=\"st0\" x1=\"25.5\" y1=\"19.5\" x2=\"74.5\" y2=\"19.5\"/>\n<line class=\"st0\" x1=\"25.5\" y1=\"84.5\" x2=\"74.5\" y2=\"84.5\"/>\n<line class=\"st0\" x1=\"45.5\" y1=\"15.5\" x2=\"54.5\" y2=\"15.5\"/>\n<path d=\"M63.8,41.5L59.3,39l-4.5-2.6c-2.1-1.2-4.9-0.5-6.1,1.7c-0.4,0.7-0.6,1.5-0.6,2.2v0.6c0,0.3,0.2,0.6,0.4,0.8l2.1,1.2\n    c0.4,0.2,0.9,0.1,1.2-0.3c0.1-0.1,0.1-0.3,0.1-0.5v-1.4c0-0.5,0.4-0.9,0.9-0.9c0.2,0,0.3,0,0.4,0.1l4.1,2.4l4.1,2.4\n    c0.4,0.2,0.6,0.8,0.3,1.2c-0.1,0.1-0.2,0.3-0.3,0.3l-4,2.3l-4.1,2.4c-0.4,0.2-1,0.1-1.2-0.3C52,50.5,52,50.3,52,50.1v-0.6\n    c0-2.5-2-4.5-4.5-4.5c-0.8,0-1.6,0.2-2.2,0.6l-4.5,2.6l-4.5,2.5c-2.1,1.2-2.9,4-1.6,6.1c0.4,0.7,1,1.3,1.6,1.6l4.5,2.5l4.5,2.6\n    c2.1,1.2,4.9,0.5,6.1-1.7c0.4-0.7,0.6-1.5,0.6-2.2V59c0-0.3-0.2-0.6-0.4-0.8L49.5,57c-0.4-0.2-0.9-0.1-1.2,0.3\n    c-0.1,0.1-0.1,0.3-0.1,0.5v1.4c0,0.5-0.4,0.9-0.9,0.9c-0.2,0-0.3,0-0.4-0.1l-4.1-2.4l-4.1-2.4c-0.4-0.2-0.6-0.8-0.3-1.2\n    c0.1-0.1,0.2-0.3,0.3-0.3l4.1-2.4l4.1-2.4c0.4-0.2,1-0.1,1.2,0.3c0.1,0.1,0.1,0.3,0.1,0.5v0.8c0,2.5,2,4.5,4.5,4.5\n    c0.8,0,1.6-0.2,2.2-0.6l4.5-2.6l4.5-2.5c1.9-1.6,1.9-4.8,0.3-6.7C63.8,42.3,63.6,42.1,63.8,41.5z\"/>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/afterpay-info/step2-small.j2"] , dependencies)